import recordStore from "@/store/record.store";
import ListItem from "../ListItem";

function UnstableRecord() {
  const unstableText = recordStore((state) => state.unstableText);
  const unstableTime = recordStore((state) => state.unstableTime);
  const lastRecord = recordStore((state) => state.lastRecord);
  if (!lastRecord) return null;
  return <ListItem isGenerating record={lastRecord} unstableText={unstableText} unstableTime={unstableTime} placeholder={"请说话，我会把语音转成文字..."} />;
}

export default UnstableRecord;